import { UseFormReturn } from "react-hook-form";
import { Box } from "@mui/material";
import WatchLaterIcon from "@mui/icons-material/WatchLater";

import {
  communicationOptions,
  getWorkingTimeOptions,
} from "../utils/selectOptions";

import CustomRadioGroup from "@/components/RHFcomponents/CustomRadioGroup";
import DropdownInput from "@/components/RHFcomponents/DropdownInput";
import { FieldLabel, FormTitle } from "../components";
import { radioGroupCommunicationStyles } from "./styles";
import { CustomRadioGroupOption } from "@/components/RHFcomponents/CustomRadioGroup/types";

interface IProp {
  methods: UseFormReturn<IFleetInquiryForm, unknown, undefined>;
}

const FormFourthStep: React.FC<IProp> = ({ methods: { control } }) => {
  const timeOptions = getWorkingTimeOptions();

  return (
    <>
      <FormTitle
        title="Almost done, when is a good time for you to consult?"
        subtitle="During this consultation, we'll discuss your fleet management goals and offer insights tailored to your needs."
        withHeader
      />

      <Box display="flex" flexDirection="column" gap={4}>
        <Box>
          <FieldLabel label="Preferred time" mb={{ xs: 3, md: 2 }} />
          <Box
            display="flex"
            justifyContent="space-between"
            gap={{ xs: 3, sm: 4, md: 6 }}
            sx={{ "& .MuiSvgIcon-root": { color: "primary.main" } }}
          >
            <DropdownInput
              name="hoursFrom"
              control={control}
              options={timeOptions}
              placeholder="Time from"
              CustomIcon={WatchLaterIcon}
            />
            <DropdownInput
              name="hoursTo"
              control={control}
              options={timeOptions}
              placeholder="Time to"
              CustomIcon={WatchLaterIcon}
            />
          </Box>
        </Box>

        <Box sx={radioGroupCommunicationStyles}>
          <FieldLabel
            label="Preferred mod of communication"
            mb={{ xs: 1, md: 2 }}
          />
          <CustomRadioGroup
            name="preferredMode"
            control={control}
            options={communicationOptions as unknown as CustomRadioGroupOption[]}
          />
        </Box>
      </Box>
    </>
  );
};

export default FormFourthStep;
